import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete-icon",
  "use": "delete-icon-usage",
  "viewBox": "0 0 18 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 18 4\" id=\"delete-icon\"><g><g><ellipse cx=\"2\" cy=\"2\" rx=\"2\" ry=\"2\" fill=\"#D8D8D8\" fill-opacity=\"1\" /></g><g><ellipse cx=\"9\" cy=\"2\" rx=\"2\" ry=\"2\" fill=\"#D8D8D8\" fill-opacity=\"1\" /></g><g><ellipse cx=\"16\" cy=\"2\" rx=\"2\" ry=\"2\" fill=\"#D8D8D8\" fill-opacity=\"1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol